import styled from "styled-components/macro";

export const SpanishReportButtonStyled = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.redMedium};
  padding: 5px 12px;
  font-size: 11px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  :hover {
    background-color: ${({ theme }) => theme.redMedium}1A;
  }

  svg {
    flex-shrink: 0;
  }
`;
